export * from './fake-backend';
export * from './auth-header';

export const accessToken  = JSON.parse(localStorage.getItem('access_token'));
export const goTo = (refName) => {
    let element = this.$refs[refName]
    element.scrollIntoView({behavior: 'smooth'})
}